import type { Component } from "svelte";
import IconSpeedometer from '~icons/mdi/speedometer';
import IconSpeedometerMedium from '~icons/mdi/speedometer-medium';
import IconSpeedometerSlow from '~icons/mdi/speedometer-slow';

export enum Difficulty {
    EASY = 'EASY',
    MODERATE = 'MODERATE',
    CHALLENGING = 'CHALLENGING',
}

export interface DifficultyMeta {
    label: string;
    Icon: Component;
    colour: string;
}

export const DIFFICULTY_METAS: Record<Difficulty, DifficultyMeta> = {
    [Difficulty.EASY]: {
        label: 'Easy',
        Icon: IconSpeedometerSlow,
        colour: 'text-difficulty-easy'
    },
    [Difficulty.MODERATE]: {
        label: 'Moderate',
        Icon: IconSpeedometerMedium,
        colour: 'text-difficulty-moderate'
    },
    [Difficulty.CHALLENGING]: {
        label: 'Challenging',
        Icon: IconSpeedometer,
        colour: 'text-difficulty-challenging'
    }
};